module.exports = __webpack_public_path__ + "public-ui/img/g3.f364f546.svg";